import { SocketData } from 'actions/socket/socketReceiveDataAction'
import { prepareMessagesStructure } from 'components/page/Chat/Messenger/Messenger.functions'

import {
  ChatMessengerState,
  MessageEditedCometContent,
} from '../ChatMessengerState'

export const updateEditedMessage = (
  chatState: ChatMessengerState,
  messageEdited?: SocketData<MessageEditedCometContent>
) => {
  if (messageEdited!.content.contactUserId !== chatState.chatData.anketa!.id) {
    return chatState
  }

  const updatedMessages = chatState.messages.map((message) => {
    if (messageEdited!.content.messageId === message.id) {
      return {
        ...message,
        message: messageEdited!.content.newText,
        last_edit_date: messageEdited!.content.editDate,
      }
    }

    // Поищем ответы на это сообщение, чтобы обновить данные в item.repliedMessage
    if (message.repliedMessage?.id === messageEdited!.content.messageId) {
      return {
        ...message,
        repliedMessage: {
          ...message.repliedMessage,
          message: messageEdited!.content.newText,
          last_edit_date: messageEdited!.content.editDate,
        },
      }
    }

    return message
  })

  return {
    ...chatState,
    messages: updatedMessages,
    messagesByDays: prepareMessagesStructure(updatedMessages),
  }
}
